export default __webpack_public_path__ + "static/media/preferedvendor_2.74c28a76.png";